import React from 'react';
import {Field} from 'redux-form';

import RoomTypeSelect from 'components/RoomTypeSelect';

export const buildRoomTypeSelectizeOption = roomType => ({
  label: roomType.name,
  value: roomType.ref,
  capacity: `${roomType.capacity} person`,
  url: roomType.image,
  object: roomType
});

export const buildRoomTypeGroupSelectizeOption = roomTypeGroup => ({
  label: roomTypeGroup.name,
  value: roomTypeGroup.id,
  object: roomTypeGroup,
  roomTypes: roomTypeGroup.roomTypes.map(buildRoomTypeSelectizeOption)
});

const SelectRoomTypeField = ({
  onChange,
  groupedRoomTypes = [],
  disabled,
  warn,
  name = 'roomType',
  validate = []
}: any) => (
  <Field
    name={name}
    validate={validate}
    component={RoomTypeSelect}
    onChange={onChange}
    groupedRoomTypes={groupedRoomTypes.map(buildRoomTypeGroupSelectizeOption)}
    disabled={disabled}
    warn={warn || []}
  />
);

export default SelectRoomTypeField;
